<template>
    <popoverUI horizontalPlacement="center">
        <flatIconButton slot="trigger" class="button--settings" :iconSize="20">
            <SettingsIconSvg slot="svgIcon" />
        </flatIconButton>
        <div slot="content" class="config-relatorio__content">
            <div class="config-relatorio__header">
                <h3 class="title">
                    <SettingsIconSvg class="title__icon" />
                    Visualização
                </h3>
            </div>
            <div class="config-relatorio__body">
                <section class="section">
                    <h4 class="section__title">Anomalias</h4>
                    <div class="section__content">
                        <checkboxUI :size="16" :checked="map.checkboxes.showLabelColorSquare.value" @change="(checked) => onChange('showLabelColorSquare', checked)">
                            <template #label>{{ map.checkboxes.showLabelColorSquare.label }}</template>
                        </checkboxUI>
                        <checkboxUI :size="16" :checked="map.checkboxes.removeLabelAnnotationStyle.value" @change="(checked) => onChange('removeLabelAnnotationStyle', checked)">
                            <template #label>{{ map.checkboxes.removeLabelAnnotationStyle.label }}</template>
                        </checkboxUI>
                    </div>
                </section>

                <section class="section">
                    <h4 class="section__title">Geral</h4>
                    <div class="section__content">
                        <checkboxUI :size="16" :checked="map.checkboxes.hideLayerTitle.value" @change="(checked) => onChange('hideLayerTitle', checked)">
                            <template #label>{{ map.checkboxes.hideLayerTitle.label }}</template>
                        </checkboxUI>
                        <checkboxUI :size="16" :checked="map.checkboxes.hideSectionTitle.value" @change="(checked) => onChange('hideSectionTitle', checked)">
                            <template #label>{{ map.checkboxes.hideSectionTitle.label }}</template>
                        </checkboxUI>
                    </div>
                </section>
            </div>
        </div>
    </popoverUI>
</template>

<script>
import popoverUI from '@/components/ui/popover.vue';
import flatIconButton from '@/components/ui/button/flatIconButton.vue';
import SettingsIconSvg from '@/assets/icons/settings.svg';
import checkboxUI from '@/components/ui/checkbox.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'configVisualizacaoRelatorio',

    components: {
        popoverUI,
        flatIconButton,
        SettingsIconSvg,
        checkboxUI
    },

    data() {
        return {
            map: {
                checkboxes: {
                    showLabelColorSquare: {
                        value: false,
                        label: 'Mostrar cores das anomalias'
                    },
                    hideLayerTitle: {
                        value: false,
                        label: 'Ocultar subtítulo'
                    },
                    hideSectionTitle: {
                        value: false,
                        label: 'Ocultar título da seção'
                    },
                    removeLabelAnnotationStyle: {
                        value: false,
                        label: 'Remover estilo das anotações'
                    },
                }
            }
        }
    },
    methods: {
        ...mapActions([
            'ACT_report_configVisualizacao_update'
        ]),
        onChange(checkboxName, checked) {
            this.map.checkboxes[checkboxName].value = checked;
            this.ACT_report_configVisualizacao_update({
                config: {
                    [checkboxName]: checked
                }
            });
        }
    },

    computed: {
        ...mapGetters([
            'GET_report_configVisualizacao',
        ])
    },

    mounted() {
        this.map.checkboxes.showLabelColorSquare.value = this.GET_report_configVisualizacao.showLabelColorSquare;
        this.map.checkboxes.hideLayerTitle.value = this.GET_report_configVisualizacao.hideLayerTitle;
        this.map.checkboxes.hideSectionTitle.value = this.GET_report_configVisualizacao.hideSectionTitle;
        this.map.checkboxes.removeLabelAnnotationStyle.value = this.GET_report_configVisualizacao.removeLabelAnnotationStyle;
    }
}
</script>

<style scoped>

.config-relatorio__content {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
    padding: var(--spacing-xs) var(--spacing-sm);
}

.config-relatorio__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.config-relatorio__header > .title {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    font-family: var(--font-family-primary);
    font-size: var(--text-sm);
    font-weight: 600;
    text-transform: uppercase;
    color: var(--color-black);
    margin: 0;
    padding: 0;
}

.config-relatorio__header .title__icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}

.config-relatorio__body {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
}

.section {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
}

.section__title {
    font-family: var(--font-family-primary);
    font-size: var(--text-xs);
    font-weight: 700;
    color: var(--color-secondary);
    letter-spacing: var(--tracking-wide);
    margin: 0;
    padding: 0;
    text-align: left;
}

.section__content {
    display: flex;
    flex-direction: column;
    padding-left: var(--spacing-sm);
    border-left: 1px solid var(--border-primary);
}

.section__content :deep(.checkbox) {
    gap: var(--spacing-xs);
}

.section__content :deep(.checkbox__label) {
    font-size: var(--text-xs);
}

</style>